<template>
    <h1 style="margin-top:320px;text-align:center">{{errMsg}}</h1>
</template>

<script>
export default {
    computed:{
        errMsg(){
            return  option.errors.filter(e=>e.code==this.$route.params.status)[0].msg;
        }
    }
}
</script>